export default __webpack_public_path__ + "static/media/Electricity_05.59ff128c.png";